import { AbstractFilterComponent } from "./abstract-filter-component.js";

export class FilterPagination extends AbstractFilterComponent {
	static selector = ".js-filter-pagination";

	static modeNumeric = "numeric";
	static modeLoadMore = "load-more";
	mode = FilterPagination.modeNumeric;

	paginationNumeric = document.querySelector(
		".js-filter--pagination-numeric"
	);
	paginationLoadMore = document.querySelector(
		".js-filter--pagination-load-more"
	);

	constructor(parent, filter, node) {
		super(parent, filter, node);
		this.bindEvents();
	}

	bindEvents() {
		let self = this;

		self.bindNumericPaginationEvents();
		self.bindLoadMorePaginationEvents();
	}

	setValue(page) {
		let self = this;
		self.node.value = page;
	}

	setNumericMode() {
		let self = this;
		self.mode = FilterPagination.modeNumeric;
	}

	setLoadMoreMode() {
		let self = this;
		self.mode = FilterPagination.modeLoadMore;
	}

	bindNumericPaginationEvents() {
		let self = this;

		if (self.paginationNumeric) {
			Array.prototype.slice
				.call(self.paginationNumeric.querySelectorAll("a"))
				.forEach((link) => {
					link.addEventListener("click", (event) => {
						event.preventDefault();

						self.setNumericMode();
						self.node.value = link.dataset.page;
						self.scrollTop();
						self.filter.forceUpdate(0);

						return false;
					});
				});
		}
	}

	bindLoadMorePaginationEvents() {
		let self = this;

		if (self.paginationLoadMore) {
			self.paginationLoadMore.addEventListener("click", (event) => {
				event.preventDefault();

				self.setLoadMoreMode();
				self.node.value = self.paginationLoadMore.dataset.page;
				self.filter.forceUpdate(0);

				return false;
			});
		}
	}

	update(current, total, icons) {
		let self = this;

		if (self.paginationNumeric) {
			self.paginationNumeric.innerHTML = self.buildNumericPagination(
				current,
				total,
				icons
			);
			self.bindNumericPaginationEvents();
		}

		if (self.paginationLoadMore) {
			self.updateLoadMorePagination(current, total, icons);
		}
	}

	updateLoadMorePagination(_current, _total, _icons) {
		let self = this;

		if (_current + 1 > _total) {
			self.paginationLoadMore.classList.add("u-hidden");
			return;
		}

		self.paginationLoadMore.classList.remove("u-hidden");
		self.paginationLoadMore.dataset.page = _current + 1;
	}

	buildNumericPagination(_current, _total, _icons) {
		let html = "";

		if (_total === 1) {
			return html;
		}

		let delta = 3;
		let left = _current - delta;
		let right = _current + delta + 1;

		let pages = [];

		for (let i = 1; i <= _total; i++) {
			if (i <= 2 || i >= _total - 1 || (i >= left && i < right)) {
				pages.push(i);
			}
		}

		if (_current !== 1) {
			html += `<li class="c-tk-pagination__arrow">
                <a href="#" rel="prev" data-page="${_current - 1}">
                    <span class="icon-svg" aria-hidden="true">
                         <svg class="icon-svg__svg" width="5.49" height="9" viewBox="0 0 5.49 9">
                          <use xlink:href="${_icons}icon-arrow-left"></use>
                        </svg>
                    </span>
                </a>
            </li>`;
		}

		pages.forEach(function (page, index) {
			html += `<li class="c-tk-pagination__item"><a href="#" class="${
				page === _current ? "is-active" : ""
			}" data-page="${page}">${page}</a></li>`;

			if (
				pages[index + 1] !== undefined &&
				page + 1 !== pages[index + 1]
			) {
				html += `<li class="c-tk-pagination__item"><span>...</span></li>`;
			}
		});

		if (_current !== _total) {
			html += `<li class="c-tk-pagination__arrow">
                <a href="#" rel="next" data-page="${_current + 1}">
                    <span class="icon-svg" aria-hidden="true">
                         <svg class="icon-svg__svg" width="6" height="9" viewBox="0 0 6 9">
                          <use xlink:href="${_icons}icon-arrow-right"></use>
                        </svg>
                    </span>
                </a>
            </li>`;
		}

		return html;
	}

	scrollTop() {
		let element = document.querySelector(".js-filter-scroll-anchor");
		if (element) {
			element.scrollIntoView({ behavior: "smooth" });
		}
	}

	getFormData() {
		let self = this;

		let val = parseInt(self.node.value);
		let def = parseInt(self.node.dataset.default);

		if (!val || val === def) {
			return {};
		}

		let result = {};
		result[self.node.name] = val;

		return result;
	}
}
